<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container">
    <div class="row">
        <div class="col-24">
            <h1>User Management</h1>
        </div>
    </div>
    <div class="row" *ngIf="isAllowAddUser">
        <div class="col-24">
            <!--<button class="button primary" [routerLink]="['/user-management/user']">Add New User</button>-->
            <button class="button primary" (click)="redirectForm()">Add New User</button>
        </div>
    </div>
    <form (keydown)="onKeyDown($event)">
        <fieldset>
            <div class="row">
                <div class="col-12">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="loginidtxt"
                                            [text]="listSearchModel.searchcriteria"
                                            id="searchcriteria"
                                            (onValueChange)="listSearchModel.searchcriteria = $event">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide"
                                           [label]="'User Type'"
                                           [selectedValue]="this.listSearchModel.roleID"
                                           [disabled]="'false'"
                                           [options]="userType"
                                           (onValueChange)="this.listSearchModel.roleID= $event">
                        </ValidatedDropDown>
                    </div>
                </div>
                <div class="col-6">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide"
                                           [label]="'Status'"
                                           [disabled]="'false'"
                                           id="statusValue"
                                           [options]="listStatus"
                                           [selectedValue]="this.listSearchModel.status"
                                           (onValueChange)="this.listSearchModel.status= $event">
                        </ValidatedDropDown>
                    </div>
                </div>
                <div class="col-6">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide"
                                           [label]="'State'"
                                           [selectedValue]="this.listSearchModel.stateAbbr"
                                           [disabled]="'false'"
                                           [options]="states"
                                           (onValueChange)="this.listSearchModel.stateAbbr= $event">
                        </ValidatedDropDown>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide"
                                           [label]="training1"
                                           [disabled]="'false'"
                                           [options]="listTrainingStatus"
                                           [selectedValue]="listSearchModel.training1"
                                           (onValueChange)="this.listSearchModel.training1= $event">

                        </ValidatedDropDown>
                    </div>
                </div>
                <div class="col-6">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide"
                                           [label]="training2"
                                           [disabled]="'false'"
                                           [options]="listTrainingStatus"
                                           [selectedValue]="listSearchModel.training2"
                                           (onValueChange)="this.listSearchModel.training2= $event">
                        </ValidatedDropDown>
                    </div>
                </div>
            </div>
            <!--<div class="row">
                <div class="col-10">
                    <div class="input-wrapper">
                        <Label for="Organization">Organization</Label>
                        <jq-org-dropdown (onValueChange)="listSearchModel.orgID = $event" #child></jq-org-dropdown>
                    </div>
                </div>
           </div>-->
        </fieldset>
        <div class="row">
            <div>
                <org-view (orgAdded)="onOrgSelected($event)"></org-view>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button type="submit" class="button primary" (click)="searchForm()">Search</button>
                <button type="reset" class="button cancel" (click)="clearForm()">Clear</button>
            </div>
        </div>
    </form>
    <div *ngIf="!displayData">
        <div class="row">
            <div class="col-24">
                <div class="bottom-10">
                    <button *ngIf="ExportAllAgentVisible" type="button" class="button primary" (click)="getAgentList()">Export All Agents</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="bottom-10">
                    <button type="button" class="button link excel" (click)="exportToExcel()">Export to Excel</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <p>Click an underlined item to see more detail.</p>
            </div>
        </div>
    </div>

    
    <div class="row" [hidden]="displayData">
        <div class="col-24" >
            <jqxGrid [width]="1240"
                     [virtualmode]="true"
                     [source]="dataAdapter"
                     [pageable]="true"
                     [pagesizeoptions]="[20, 50, 100]"
                     [pagesize]="50"
                     [sortable]="true"
                     [columns]="columns"
                     (onCellclick)="Cellclick($event)"
                     [filterable]="true"
                     [autoshowcolumnsmenubutton]="false"
                     [rendergridrows]="rendergridrows"
                     (onSort)="onSort($event)"
                     (onFilter)="onFilter($event)"
                     (onPagesizechanged)="onPageSizeChanged($event)"
                     [updatefilterconditions]="updatefilterconditions" 
                     [columnsresize]="true" 
                  
                     [selectionmode]="'multiplecellsadvanced'"                    
                     [ready] ="ready"
                     #TreeGrid>
            </jqxGrid>
        </div>
    </div>
<div *ngIf="!displayEmptyData">
    <div class="">
        <p> No records Found</p>
    </div>
</div>
</div>

